// extracted by mini-css-extract-plugin
export default {"onSelectedtab":"styles_onSelectedtab__Ux9+N"};